import * as auth from './auth.js'
import * as actions from './actions.js'
import scoketConnect from './scoketConnect.js'
import echartsInit from './echartsInit.js'
import * as common from './common.js'
import * as dataProcess from './dataProcess.js'

export default {
    ...auth,
    ...actions,
    scoketConnect,
    echartsInit,
    ...common,
    ...dataProcess
}